export const undefined_or_null_or_value = el => (el === null || el === undefined ? null : el);

export const toFloat = number => parseFloat(number.toFixed(1));

/**
 * This function takes an array of fields to perform case insensitive filters within lists
 * @param {string} values - Values can be passed as a string "name" or as an array ["name", "start_date"]
 * @returns {boolean} The search's result
 */
export const matchSearch = (values, search) => {
    if (!Array.isArray(values)) {
        values = [values];
    }
    const reg = new RegExp(search, 'gi');
    return values.some(value => reg.test(value));
};

/**
 * This function allows to dymalically edit list using front toggles, it can either add items , or delete at specific index
 * @param {array} source - A list of objects
 * @param {object} additions - An element to be pushed to the source list
 * @param {number} value - Value to switch from push to splice (usually null/index)
 * @returns {array} Returns edited source list.
 */
export const pushOrSplice = (source, additions, value) => {
    if (!source) {
        throw new Error('[pushOrSplice] source is mandatory');
    }
    const addition = { ...additions };
    let new_source = [...source];

    if (!value && value !== 0) {
        return [...new_source, addition];
    } else {
        new_source.splice(value, 1);
        return new_source;
    }
};

export const quickFilter = (source, field, name, value) => {
    let _filters = { ...source };
    let _field = _filters[field] || new Set([]);

    if (!value) {
        _field.delete(name);
    } else {
        _field.add(name);
    }

    if (!_field.size && !value) {
        delete _filters[field];
        return { ..._filters };
    }

    return { ...source, [field]: _field };
};

export const requestCount = (loading, request) => {
    if (loading) {
        return '--';
    }
    return Number.parseInt(request?.__meta?.headers.get('total-count')) || 0;
};
